module.exports = __webpack_public_path__ + "img/phone-key.6e22cd9b.svg";